var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSentenceList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 9.146v28.976c0 1.563-1.234 2.831-2.756 2.831H3.756C2.234 40.953 1 39.685 1 38.122V3.785C1 2.221 2.234.953 3.756.953h26.41C31.73.953 33 2.25 33 3.85v5.296z",
    stroke: "#EFEFEF",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.552 35.778H6.446a.485.485 0 01-.497-.472c0-.261.223-.472.497-.472h7.106c.275 0 .497.211.497.472 0 .26-.222.472-.497.472M27.591 7.487H6.435a.48.48 0 01-.48-.392.469.469 0 01.454-.552h21.145c.236 0 .46.165.492.404a.468.468 0 01-.455.54M17 10.83H6.42a.465.465 0 01-.459-.472c0-.26.206-.472.46-.472H17c.253 0 .459.212.459.472 0 .261-.206.472-.459.472M27.591 14.22H6.41a.466.466 0 01-.46-.472c0-.26.206-.472.46-.472H27.59c.254 0 .46.212.46.472 0 .261-.206.472-.46.472M21.888 17.61H6.42a.465.465 0 01-.458-.472c0-.26.205-.472.458-.472h15.468c.253 0 .459.212.459.472 0 .261-.206.472-.459.472",
    fill: "#CFCFCF"
  }))));
}
export default SvgSentenceList;